import { render, staticRenderFns } from "./VClockProjectReport.vue?vue&type=template&id=a9a74620&"
import script from "./VClockProjectReport.vue?vue&type=script&lang=js&"
export * from "./VClockProjectReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports